import SectionHeading from "@/components/base/SectionHeading";
import SubmitForm from "@/components/feature/SubmitForm";

const guidelines = [
  {
    icon: "ri-shield-keyhole-line",
    title: "不留身份痕迹",
    desc: "接口不记录 IP 与设备信息，投稿后的原始附件在整理完成当日销毁。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "只写事实描述",
    desc: "请描述你亲眼看到、亲手经手的过程，主观评价与推测请单独说明。",
  },
  {
    icon: "ri-scales-3-line",
    title: "接受核查",
    desc: "涉及具体结论的内容，我们会尝试寻找第二个独立来源后再公开发布。",
  },
];

export default function SubmitSection() {
  return (
    <section id="submit" className="ink-panel relative overflow-hidden">
      <div className="noise absolute inset-0 opacity-70" />
      <div className="wrap relative py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-5">
            <SectionHeading
              index="06"
              eyebrow="Submit a Tip"
              title="匿名投稿入口"
              desc="不需要注册，不需要留下任何身份信息。你只需要把事情说清楚，剩下的交给夜班编辑。"
              tone="dark"
            />

            <ul className="mt-10 space-y-6">
              {guidelines.map((item) => (
                <li key={item.title} className="flex items-start gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-50/10 text-accent-400">
                    <i className={`${item.icon} text-lg`} />
                  </span>
                  <span>
                    <span className="block font-heading text-base font-bold text-background-50">
                      {item.title}
                    </span>
                    <span className="mt-1 block text-sm leading-relaxed text-background-300">
                      {item.desc}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-7">
            <SubmitForm />
          </div>
        </div>
      </div>
    </section>
  );
}